import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './ParadigmaFileLink.css';

class ParadigmaFileLink extends Component {
  constructor(props){
       super(props);
  }

  static propTypes = {
      filename: PropTypes.string,
      link : PropTypes.string,
      message:PropTypes.string
  }

  render() {
       return (
         <React.Fragment>
         {this.props.message}
         {
              this.props.filename === undefined || this.props.filename === null ?
              "No hay archivo asignado" :
                   this.props.link === undefined || this.props.link === null ?
                   this.props.filename :
                   <a target={"_blank"} href={this.props.link}>{this.props.filename}</a>
         }
        </React.Fragment>
       );
  }
}

export default ParadigmaFileLink;



// WEBPACK FOOTER //
// ./src/components/ParadigmaFileUploader/ParadigmaFileLink.js